import * as React from "react";
import {EntriesBootstrap} from "../Entries/EntriesBootstrap";
let ReactDOM = require("react-dom");
import 'shared/styles/bootstrap.scss';
import {SpinnerButton} from "shared/controls/SpinnerButton";
import {RNTextInput} from "shared/controls/SingleInputs/RNTextInput";
import {CodeMirrorInput, CustomFieldData} from "./CodeMirrorInput";
import {ToastService} from "shared/utilities/services/ToastService";
import {SearchableDropDown} from "InternalShared/PageBuilder/Controls/Properties/SearchableDropDown";
import {SearchableSelect} from "shared/controls/SingleInputs/SearchableSelect/SearchableSelect";
import {WpAjaxPost} from "shared/utilities/ajax/WPAjaxPost";



declare let custom_fields:any;
export class CustomFieldsBootstrap extends React.Component<CustomFieldsBootstrapProps, CustomFieldsBootstrapState> {
    static defaultProps: Partial<CustomFieldsBootstrapProps> = {};
    private CustomField:CustomFieldData;


    constructor(props: CustomFieldsBootstrapProps) {
        super(props);
        WpAjaxPost.SetGlobalVar(custom_fields);
        this.state = {
            IsBusy:false
        };
        this.CustomField=new CustomFieldData();
        this.CustomField.Id=0;
        this.CustomField.Code='';
        this.CustomField.Name='';
        this.CustomField.FormId=0;

        if(custom_fields.CustomField!=null)
        {
            this.CustomField.Id=custom_fields.CustomField.Id;
            this.CustomField.Code=custom_fields.CustomField.Code;
            this.CustomField.Name=custom_fields.CustomField.Name;
            this.CustomField.FormId=custom_fields.CustomField.FormId;
        }
    }

    public render() {
        return (
            <div className={'rednao'} style={{padding:'10px 10px 10px 0'}}>
                <h1 style={{marginBottom:15}}>Custom Fields</h1>
                <SpinnerButton IsBusy={this.state.IsBusy} OnClick={()=>this.Save()} >Save</SpinnerButton>

                <RNTextInput placeholder={'Field Name'} Label={'Custom Field Name'} Value={this.CustomField.Name} onChange={x=>{this.CustomField.Name=x;this.forceUpdate()}} style={{marginTop:15}}/>
                <SearchableSelect Label={'Form'} Value={this.CustomField.FormId} onChange={x=>{this.CustomField.FormId=x as any;this.forceUpdate()}}>
                    {custom_fields.FormList.map(x=>
                        <option value={x.Id}>{x.Name}</option>
                    )}
                </SearchableSelect>

                <label style={{marginTop:5,fontWeight:'bold'}}>Code</label>
                <CodeMirrorInput CustomFieldData={this.CustomField}/>

            </div>

        )
    }

    private async Save() {
        if(this.CustomField.Name.trim()=='')
        {
            ToastService.SendErrorMessage('Field name is mandatory');
            return;
        }

        if(this.CustomField.FormId==0)
        {
            ToastService.SendErrorMessage('Form is mandatory');
            return;
        }

        if(this.CustomField.Code.trim()=='')
        {
            ToastService.SendErrorMessage('Field name is mandatory');
            return;
        }

        this.setState({IsBusy:true});
        let result=await WpAjaxPost.Post('save',this.CustomField);
        this.setState({IsBusy:false});

        if(result==null)
            return;

        this.CustomField.Id=result.Id;

    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface CustomFieldsBootstrapProps {

}

interface CustomFieldsBootstrapState {
    IsBusy:boolean;
}


//#endregion "My Region"


window.addEventListener('load',()=>{
    ReactDOM.render(<CustomFieldsBootstrap/>,document.getElementById('AppRot'));
});